import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'StockItemDatePicker';

/** Portal node id; react-datepicker creates this on document.body if missing. */
export const STOCK_ITEM_DATEPICKER_PORTAL_ID = 'stock-item-datepicker-portal';

/**
 * Shared react-datepicker props so the calendar renders outside overflow:hidden
 * ancestors (`.glass-table-wrap`, `.modal-content`). Without a portal, short
 * stock tables clip month/year controls and later dates.
 *
 * `popperClassName` pairs with CSS z-index above Bootstrap modal (1055).
 */
export const STOCK_ITEM_DATEPICKER_OVERFLOW_PROPS = {
  portalId: STOCK_ITEM_DATEPICKER_PORTAL_ID,
  popperClassName: 'stock-item-datepicker-popper',
  popperPlacement: 'bottom-start',
  popperProps: { strategy: 'fixed' },
};

/**
 * Logs when a stock-item calendar opens (expiry / opened-on).
 *
 * @param {'expiry'|'openedOn'} field
 * @param {Object} [extra]
 */
export function logStockItemDatePickerOpen(field, extra = {}) {
  logInfo(LOG_CONTEXT, 'date picker opened', { field, ...extra });
}
